import { createApp } from 'vue';
import translatePlugin from '@/src/vue/plugins/translate.js';
// import utilsPlugin from '@/src/vue/plugins/utilsPlugin.js';

export function createVueApp (vueComponent, props) {
	const componentName = vueComponent.__name;
	const componentProps = props || js_params?.module?.[componentName] || {};

	const vueApp = createApp({ render: () => h(vueComponent, componentProps) });
	vueApp.use(translatePlugin);

	return vueApp;
}
